import React, { useEffect, useState } from "react";
import styles from "./FormPage.module.scss";
import { GoInfo } from "react-icons/go";
import { HiChevronDoubleUp, HiChevronDoubleDown } from "react-icons/hi";
import logoImg from "../../assets/images/logo-green.png";
import classNames from "classnames";
import { database } from "../../FirebaseConfig";
import { collection, addDoc } from "firebase/firestore";
import logo from "../../assets/images/logo-green.png";
import loanPng from "../../assets/images/loan.png";
import loanGif from "../../assets/images/loan.gif";
import securityPng from "../../assets/images/security.png";
import securityGif from "../../assets/images/security.gif";
import companyPng from "../../assets/images/company.png";
import companyGif from "../../assets/images/company.gif";
import directorPng from "../../assets/images/director.png";
import directorGif from "../../assets/images/director.gif";
import otherPng from "../../assets/images/other.png";
import otherGif from "../../assets/images/other.gif";
import loading from "../../assets/images/loading.gif";
import { useNavigate } from "react-router-dom"

const FormPage = () => {
  useEffect(() => {
    document.title = "Briding 365 | Form";
    window.scrollTo(0, 0);
    return () => {
      localStorage.removeItem("initialObj");
    };
  }, []);
  const navigate = useNavigate()
  const today = new Date();
  const date =
    today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear();
  const time =
    today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
  // const [purpose, setPurpose] = useState();
  const collectionRef = collection(database, "forms");
  const initialValue = {
    userName: "",
    userContact: "",
    userEmail: "",
    propertyUse: "",
    whenMoneyNeeded: "",
    purpose: "",
    currentLoanFromBridgingLender: "",
    whenLoanCompleted: "",
    howMuchToBorrow: "",
    numOfMonthsLoanFor: "",
    monthlyOrTermPay: "",
    howPaybackLoan: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    postcode: "",
    propertyValuation: "",
    propertyDescription: "",
    numberOfBedrooms: "",
    numberOfFloors: "",
    isExCouncilProperty: "",
    isStandardConstruction: "",
    constructionDescription: "",
    tenureOfProperty: "",
    assetDescription: "",
    addAnotherProperty: "",
    nameOfCompayForBorrowingIn: "",
    companyRegistrationNumber: "",
    companyAddress1: "",
    companyAddress2: "",
    companyCity: "",
    companyPostCode: "",
    directorFirstName: "",
    directorLastName: "",
    directorTitle: "",
    directorDateOfBirth: "",
    directorAddress1: "",
    directorAddress2: "",
    directorTown: "",
    directorPostCode: "",
    directorNumber: "",
    defaultInSixYears: "",
    everDeclaredBankrupt: "",
    otherMsg: "",
    submittedOnDate: date,
    submittedOnTime: time,
  };
  const [formdata, setFormdata] = useState(initialValue);
  const [showLoading, setShowLoading] = useState(false);

  const submitHandler = () => {
    if (
      !formdata.purpose ||
      // !formdata.currentLoanFromBridgingLender ||
      // !formdata.whenLoanCompleted ||
      !formdata.howMuchToBorrow ||
      !formdata.numOfMonthsLoanFor ||
      !formdata.monthlyOrTermPay ||
      !formdata.howPaybackLoan ||
      !formdata.addressLine1 ||
      // !formdata.addressLine2 ||
      !formdata.city ||
      !formdata.postcode ||
      !formdata.propertyValuation ||
      !formdata.propertyDescription ||
      !formdata.numberOfBedrooms ||
      !formdata.numberOfFloors ||
      !formdata.isExCouncilProperty ||
      !formdata.isStandardConstruction ||
      !formdata.constructionDescription ||
      !formdata.tenureOfProperty ||
      !formdata.assetDescription ||
      // !formdata.addAnotherProperty ||
      !formdata.nameOfCompayForBorrowingIn ||
      !formdata.companyRegistrationNumber ||
      !formdata.companyAddress1 ||
      // !formdata.companyAddress2 ||
      !formdata.companyCity ||
      !formdata.companyPostCode ||
      !formdata.directorFirstName ||
      !formdata.directorLastName ||
      !formdata.directorDateOfBirth ||
      !formdata.directorAddress1 ||
      // !formdata.directorAddress2 ||
      !formdata.directorTown ||
      !formdata.directorNumber ||
      !formdata.defaultInSixYears ||
      !formdata.everDeclaredBankrupt ||
      !formdata.otherMsg
    ) {
      alert("Please fill all the details to continue");
      return;
    }
    setShowLoading(true);
    addDoc(collectionRef, formdata)
      .then((response) => {
        alert("Form submitted successfully ! ");
        setShowLoading(false);
        setFormdata(initialValue);
        navigate("/formsuccess", { replace: true })
      })
      .catch((error) => {
        alert("Oops !! Something went wrong. ");
        setShowLoading(false);
      });
  };
  const [step, setStep] = useState("initial");
  const intialSubmitHandler = () => {
    if (
      !formdata.userName ||
      !formdata.userContact ||
      !formdata.userEmail ||
      !formdata.propertyUse ||
      !formdata.whenMoneyNeeded
    ) {
      alert("Please fill all the details to continue");
      return;
    }
    localStorage.setItem("initialObj", JSON.stringify(formdata));
    setStep("final");
    window.scrollTo(0, 0);
  };
  const SaveForLaterHandler = () => {
    alert("Feature to be added soon.");
  };
  const [resultsShown, setResultsShown] = useState(false);
  let mql = window.matchMedia("(max-width:800px)");
  const simpleInterest =
    (formdata.howMuchToBorrow * 0.69 * formdata.numOfMonthsLoanFor) / 1200;
  console.log("simpleInterest", simpleInterest);
  const amountDue = Number(
    Number(formdata.howMuchToBorrow) + Number(simpleInterest)
  ).toFixed(0);
  console.log("amountDue", amountDue);
  const monthlyPayment = Number(
    amountDue / formdata.numOfMonthsLoanFor
  ).toFixed(0);
  console.log("monthlyPayment", monthlyPayment);
  const maxBorrowLimit = 0.65 * formdata.propertyValuation;
  const lTV = (formdata.howMuchToBorrow / formdata.propertyValuation).toFixed(
    2
  );
  console.log(lTV);
  console.log(isNaN(lTV));
  const finalFormUI = () => {
    return (
      <div className={styles.formPage}>
        <span
          title="form results"
          className={styles.finalResults}
          onClick={() => setResultsShown(!resultsShown)}
        >
          {" "}
          <span> Your results</span>
          <span>
            {" "}
            {!resultsShown ? (
              <HiChevronDoubleUp className={styles.docIcon} />
            ) : (
              <HiChevronDoubleDown className={styles.docIcon} />
            )}
          </span>
        </span>{" "}
        <div className={styles.left}>
          <img src={logoImg} alt="" />
          <ul>
            <li>
              {" "}
              <a href="#section1">
                <span>About the Loan </span>
                <span>
                  <img src={loanPng} alt="" />
                </span>{" "}
              </a>
            </li>
            <li>
              <a href="#section2">
                <span> About the Security</span>{" "}
                <span>
                  {" "}
                  <img src={securityPng} alt="" />
                </span>{" "}
              </a>
            </li>
            <li>
              <a href="#section3">
                {" "}
                <span> About the Company</span>{" "}
                <span>
                  {" "}
                  <img src={companyPng} alt="" />
                </span>{" "}
              </a>
            </li>
            <li>
              {" "}
              <a href="#section4">
                {" "}
                <span> About the Director</span>{" "}
                <span>
                  {" "}
                  <img src={directorPng} alt="" />
                </span>
              </a>
            </li>
            <li>
              {" "}
              <a href="#section5">
                {" "}
                <span>Additional Information</span>{" "}
                <span>
                  {" "}
                  <img src={otherPng} alt="" />
                </span>{" "}
              </a>
            </li>
          </ul>
          <div className={styles.btns}>
            <button className={styles.btn1}>Save for later</button>
            <button className={styles.btn2}>Email me</button>
            <button
              className={styles.btn1}
              onClick={() => {
                setStep("initial");
                window.scrollTo(0, 0);
              }}
            >
              Go back
            </button>
          </div>
        </div>
        <div className={styles.center}>
          {" "}
          <div className={styles.section} id="section1">
            <p className={styles.head}>Section 1/5 : About the Loan </p>
            <img src={loanPng} alt="" srcset="" className={styles.png} />
            <div className={styles.gifContainer}>
              <img src={loanGif} alt="" className={styles.gif} />
            </div>
            <p className={styles.text}>
              Here we will be asking you about how much you want to borrow and
              for how long, followed by a little about your property then
              details about you and your company. It should not take more than
              10 mins... personalised.
            </p>
            <form action="" className={styles.form1}>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    What is the purpose of the bridging loan?{" "}
                  </span>

                  <GoInfo className={styles.infoIcon} />
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <select
                    name=""
                    id=""
                    className={styles.answer}
                    value={formdata.purpose}
                    onChange={(e) => {
                      setFormdata({ ...formdata, purpose: e.target.value });
                    }}
                  >
                    <option
                      value=""
                      selected
                      disabled
                      className={styles.option}
                    >
                      select option
                    </option>
                    <option value="Purchase" className={styles.option}>
                      Purchase
                    </option>
                    <option value="Refinance" className={styles.option}>
                      Refinance
                    </option>
                    <option value="CapitalRaise" className={styles.option}>
                      Capital raise- home improvements
                    </option>
                    <option value="Stop Reposessions" className={styles.option}>
                      Stop a repossession
                    </option>
                  </select>
                </div>
              </div>
              {formdata.purpose === "Refinance" && (
                <div className={styles.inputBox}>
                  <label htmlFor="" className={styles.question}>
                    <span className={styles.questionText}>
                      {" "}
                      Is your current loan from a bridging lender?
                    </span>
                    <GoInfo className={styles.infoIcon} />
                  </label>

                  <div className={styles.answerBlock}>
                    {" "}
                    <select
                      name=""
                      id=""
                      className={styles.answer}
                      value={formdata.currentLoanFromBridgingLender}
                      onChange={(e) => {
                        setFormdata({
                          ...formdata,
                          currentLoanFromBridgingLender: e.target.value,
                        });
                      }}
                    >
                      <option
                        value=""
                        selected
                        disabled
                        className={styles.option}
                      >
                        select option
                      </option>
                      <option value="Yes" className={styles.option}>
                        Yes
                      </option>
                      <option value="No" className={styles.option}>
                        No
                      </option>
                    </select>
                  </div>
                </div>
              )}
              {formdata.purpose === "Stop Reposessions" && (
                <div className={styles.inputBox}>
                  <label htmlFor="" className={styles.question}>
                    <span className={styles.questionText}>
                      {" "}
                      When do you need the loan to be completed by?
                    </span>
                    <GoInfo className={styles.infoIcon} />
                  </label>

                  <div className={styles.answerBlock}>
                    {" "}
                    <select
                      name=""
                      id=""
                      className={styles.answer}
                      value={formdata.whenLoanCompleted}
                      onChange={(e) => {
                        setFormdata({
                          ...formdata,
                          whenLoanCompleted: e.target.value,
                        });
                      }}
                    >
                      <option
                        value=""
                        selected
                        disabled
                        className={styles.option}
                      >
                        select option
                      </option>
                      <option value="Under 48 hours" className={styles.option}>
                        under 48 hours
                      </option>
                      <option value="Under a week" className={styles.option}>
                        under a week
                      </option>
                      <option value="Under a month" className={styles.option}>
                        under a month
                      </option>
                    </select>
                  </div>
                </div>
              )}
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    How much would you like to borrow?
                  </span>
                  <GoInfo className={styles.infoIcon} />
                </label>

                <div className={styles.answerBlock}>
                  {" "}
                  <input
                    type="number"
                    placeholder="Enter amount in GBP"
                    className={styles.answer}
                    value={formdata.howMuchToBorrow}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        howMuchToBorrow: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    Please select the number of months you would like the loan
                    for
                  </span>

                  <GoInfo className={styles.infoIcon} />
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <select
                    name=""
                    id=""
                    className={styles.answer}
                    value={formdata.numOfMonthsLoanFor}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        numOfMonthsLoanFor: e.target.value,
                      });
                    }}
                  >
                    <option value="" selected disabled>
                      select option
                    </option>
                    <option value="3">3 months</option>
                    <option value="4">4 months</option>
                    <option value="5">5 months</option>
                    <option value="6">6 months</option>
                    <option value="7">7 months</option>
                    <option value="8">8 months</option>
                    <option value="9">9 months</option>
                    <option value="10">10 months</option>
                    <option value="11">11 months</option>
                    <option value="12">12 months</option>
                    <option value="13">13 months</option>
                    <option value="14">14 months</option>
                    <option value="15">15 months</option>
                    <option value="16">16 months</option>
                    <option value="17">17 months</option>
                    <option value="18">18 months</option>
                  </select>
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    Would you like to make monthly payments or simply pay the
                    full balance due on exiting the loan?
                  </span>

                  <GoInfo className={styles.infoIcon} />
                </label>
                <div
                  className={classNames(
                    styles.answerBlock,
                    styles.radioBoxBlock
                  )}
                >
                  {" "}
                  <span>
                    {" "}
                    <input
                      className={classNames(styles.answer, styles.radioBox)}
                      type="radio"
                      name="paymentTerm"
                      value="Every month"
                      onChange={(e) => {
                        setFormdata({
                          ...formdata,
                          monthlyOrTermPay: e.target.value,
                        });
                      }}
                    />
                    I'd like to pay the interest due every month
                  </span>
                  <span>
                    <input
                      className={classNames(styles.answer, styles.radioBox)}
                      type="radio"
                      name="paymentTerm"
                      value="At the end"
                      onChange={(e) => {
                        setFormdata({
                          ...formdata,
                          monthlyOrTermPay: e.target.value,
                        });
                      }}
                    />
                    I'd like to make one payment at the end of the loan
                  </span>
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    How will you be paying the loan back?{" "}
                  </span>
                  <GoInfo className={styles.infoIcon} />
                </label>
                <div
                  className={classNames(
                    styles.answerBlock,
                    styles.radioBoxBlock
                  )}
                >
                  {" "}
                  <span>
                    {" "}
                    <input
                      className={classNames(styles.answer, styles.radioBox)}
                      type="radio"
                      name="payingVia"
                      value="By selling property"
                      onChange={(e) => {
                        setFormdata({
                          ...formdata,
                          howPaybackLoan: e.target.value,
                        });
                      }}
                    />
                    By selling the property
                  </span>
                  <span>
                    <input
                      className={classNames(styles.answer, styles.radioBox)}
                      type="radio"
                      name="payingVia"
                      value="Refinancing to a term lender"
                      onChange={(e) => {
                        setFormdata({
                          ...formdata,
                          howPaybackLoan: e.target.value,
                        });
                      }}
                    />
                    Refinancing to a term lender
                  </span>
                  <span>
                    <input
                      className={classNames(styles.answer, styles.radioBox)}
                      type="radio"
                      name="payingVia"
                      value="other"
                      onChange={(e) => {
                        setFormdata({
                          ...formdata,
                          howPaybackLoan: e.target.value,
                        });
                      }}
                    />
                    Other-please specify{" "}
                  </span>
                  {/* <select name="" id="" className={styles.answer}>
              <option value="" selected disabled>
                select option
              </option>
              <option value="">Selling the property</option>
              <option value="">Refinancing to a term lender</option>
              <option value="">Other-please specify</option>
            </select> */}
                </div>
              </div>
            </form>
          </div>
          <div className={styles.section} id="section2">
            <p className={styles.head}>Section 2 / 5: About the Security</p>
            <img src={securityPng} alt="" srcset="" className={styles.png} />
            <div className={styles.gifContainer}>
              <img src={securityGif} alt="" className={styles.gif} />
            </div>
            <p className={styles.text}>
              Now we understand how much you’re looking to borrow, can you now
              tell us about the asset you are borrowing against?
            </p>

            <form action="" className={styles.form1}>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}> Address Line 1 </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <input
                    type="text"
                    placeholder="Enter your address"
                    className={styles.answer}
                    value={formdata.addressLine1}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        addressLine1: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    Address Line 2 (optional)
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <input
                    type="text"
                    placeholder="Enter your address"
                    className={styles.answer}
                    value={formdata.addressLine2}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        addressLine2: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    Which city or town is the property located in?
                    <GoInfo className={styles.infoIcon} />{" "}
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <input
                    type="text"
                    placeholder="Enter city or town name"
                    className={styles.answer}
                    value={formdata.city}
                    onChange={(e) => {
                      setFormdata({ ...formdata, city: e.target.value });
                    }}
                  />
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    What is the postcode?
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  <input
                    type="text"
                    placeholder="Enter postcode"
                    className={styles.answer}
                    value={formdata.postcode}
                    onChange={(e) => {
                      setFormdata({ ...formdata, postcode: e.target.value });
                    }}
                  />
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    What is the estimated property valuation?
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  <input
                    type="number"
                    placeholder="Enter valuation in GBP"
                    className={styles.answer}
                    value={formdata.propertyValuation}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        propertyValuation: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>

              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    Please select the best description of the property below
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <select
                    name=""
                    id=""
                    className={styles.answer}
                    value={formdata.propertyDescription}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        propertyDescription: e.target.value,
                      });
                    }}
                  >
                    <option value="" selected disabled>
                      select option
                    </option>
                    <option value="House">House</option>
                    <option value="Flat">Flat</option>
                    <option value="HMO (House in Multiple Occupation)">
                      HMO (House in Multiple Occupation)
                    </option>
                    <option value="Commercial property">
                      Commercial property
                    </option>
                    <option value="Land with or without planning permission">
                      Land with or without planning permission
                    </option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    How many bedrooms does the property have?
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <input
                    type="number"
                    placeholder="Enter number of bedrooms"
                    className={styles.answer}
                    value={formdata.numberOfBedrooms}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        numberOfBedrooms: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    How many floors are in the building?
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <input
                    type="number"
                    placeholder="Enter number of floors"
                    className={styles.answer}
                    value={formdata.numberOfFloors}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        numberOfFloors: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    Is it an ex-council property?
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <select
                    name=""
                    id=""
                    className={styles.answer}
                    value={formdata.isExCouncilProperty}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        isExCouncilProperty: e.target.value,
                      });
                    }}
                  >
                    <option value="" selected disabled>
                      select option
                    </option>
                    <option value="yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    Is property of standard construction? Please select below
                    and tell us more.
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  <select
                    name=""
                    id=""
                    className={styles.answer}
                    value={formdata.isStandardConstruction}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        isStandardConstruction: e.target.value,
                      });
                    }}
                  >
                    <option value="" selected disabled>
                      select option
                    </option>
                    <option value="yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>

                {/* <div className={styles.answerBlock}></div> */}

                <div className={styles.answerBlock}>
                  {" "}
                  <textarea
                    name=""
                    placeholder="Tell us more"
                    id=""
                    cols="40"
                    rows="5"
                    className={classNames(styles.answer, styles.textarea)}
                    value={formdata.constructionDescription}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        constructionDescription: e.target.value,
                      });
                    }}
                  ></textarea>
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    Do you know the tenure of the property?
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  <select
                    name=""
                    id=""
                    className={styles.answer}
                    value={formdata.tenureOfProperty}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        tenureOfProperty: e.target.value,
                      });
                    }}
                  >
                    <option value="" selected disabled>
                      select option
                    </option>
                    <option value="Freehold">Freehold</option>
                    <option value="Leasehold">Leasehold</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    Please describe the asset:
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <textarea
                    name=""
                    placeholder="Describe asset"
                    id=""
                    cols="40"
                    rows="5"
                    className={classNames(styles.answer, styles.textarea)}
                    value={formdata.assetDescription}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        assetDescription: e.target.value,
                      });
                    }}
                  ></textarea>
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    Would you like to add another property?
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  <select
                    name=""
                    id=""
                    className={styles.answer}
                    value={formdata.addAnotherProperty}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        addAnotherProperty: e.target.value,
                      });
                    }}
                  >
                    <option value="" selected disabled>
                      select option
                    </option>
                    <option value="yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div className={styles.section} id="section3">
            <p className={styles.head}>Section 3 / 5: About the Company</p>
            <img src={companyPng} alt="" srcset="" className={styles.png} />
            <div className={styles.gifContainer}>
              <img src={companyGif} alt="" className={styles.gif} />
            </div>
            <p className={styles.text}>
              Thanks for telling us about how much you want to borrow and the
              security asset. Now would you mind telling us about the company we
              will be lending to?
            </p>

            <form action="" className={styles.form1}>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    What is the name of the company you are borrowing in?{" "}
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <input
                    type="text"
                    placeholder="Enter name of your company"
                    className={styles.answer}
                    value={formdata.nameOfCompayForBorrowingIn}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        nameOfCompayForBorrowingIn: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    What is the company registration number?
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  <input
                    type="text"
                    placeholder="Enter company registration number"
                    className={styles.answer}
                    value={formdata.companyRegistrationNumber}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        companyRegistrationNumber: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    What is the registered company address?
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <input
                    type="text"
                    placeholder="Enter company address"
                    className={styles.answer}
                    value={formdata.companyAddress1}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        companyAddress1: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    Address Line 2 (optional)
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  <input
                    type="text"
                    placeholder="Enter Address"
                    className={styles.answer}
                    value={formdata.companyAddress2}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        companyAddress2: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    City or Town
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <input
                    type="text"
                    placeholder="Enter City or Town"
                    className={styles.answer}
                    value={formdata.companyCity}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        companyCity: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    Postcode?
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  <input
                    type="text"
                    placeholder="Postcode?"
                    className={styles.answer}
                    value={formdata.companyPostCode}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        companyPostCode: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
            </form>
          </div>
          <div className={styles.section} id="section4">
            <p className={styles.head}>Section 4 / 5: About the Director</p>
            <img src={directorPng} alt="" srcset="" className={styles.png} />
            <div className={styles.gifContainer}>
              <img src={directorGif} alt="" className={styles.gif} />
            </div>
            <p className={styles.text}>
              We're getting excited as we are close to the end, now can you tell
              us about yourself?
            </p>

            <form action="" className={styles.form1}>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    What is Your First Name?{" "}
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  <input
                    type="text"
                    placeholder="Enter Your First Name"
                    className={styles.answer}
                    value={formdata.directorFirstName}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        directorFirstName: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    What is Your Last Name?
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <input
                    type="text"
                    placeholder="Enter Your Last Name"
                    className={styles.answer}
                    value={formdata.directorLastName}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        directorLastName: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    What is Your Title
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  <select
                    name=""
                    id=""
                    className={styles.answer}
                    value={formdata.directorTitle}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        directorTitle: e.target.value,
                      });
                    }}
                  >
                    <option value="" selected disabled>
                      select option
                    </option>
                    <option value="yes">Mr</option>
                    <option value="No">Mrs</option>
                  </select>
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    When Were You Born?
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <input
                    type="date"
                    placeholder="Select your birthdate"
                    className={styles.answer}
                    value={formdata.directorDateOfBirth}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        directorDateOfBirth: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    Address Line 1
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <input
                    type="text"
                    placeholder="Enter Address Line 1"
                    className={styles.answer}
                    value={formdata.directorAddress1}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        directorAddress1: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    Address Line 2 (optional)
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <input
                    type="text"
                    placeholder="Enter Address"
                    className={styles.answer}
                    value={formdata.directorAddress2}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        directorAddress2: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    Town or City
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <input
                    type="text"
                    placeholder="Enter your town or City"
                    className={styles.answer}
                    value={formdata.directorTown}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        directorTown: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    Postal code?
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <input
                    type="text"
                    placeholder="Enter postal code"
                    className={styles.answer}
                    value={formdata.directorPostCode}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        directorPostCode: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    What is the Best Number To Contact You?
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <input
                    type="number"
                    placeholder="Enter your contact number"
                    className={styles.answer}
                    value={formdata.directorNumber}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        directorNumber: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    Have you had any CCJ's or the Defaults in last 6 years?
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <select
                    name=""
                    id=""
                    className={styles.answer}
                    value={formdata.defaultInSixYears}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        defaultInSixYears: e.target.value,
                      });
                    }}
                  >
                    <option value="" selected disabled>
                      select option
                    </option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    Have you ever been declared bankrupt?
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <select
                    name=""
                    id=""
                    className={styles.answer}
                    value={formdata.everDeclaredBankrupt}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        everDeclaredBankrupt: e.target.value,
                      });
                    }}
                  >
                    <option value="" selected disabled>
                      select option
                    </option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div className={styles.section} id="section5">
            <p className={styles.head}>Section 5 / 5: Anything else?</p>
            <img src={otherPng} alt="" srcset="" className={styles.png} />
            <div className={styles.gifContainer}>
              <img src={otherGif} alt="" className={styles.gif} />
            </div>
            <p className={styles.text}>
              For this last section, here's your chance to tell us anything else
              you think we need to know about you or the application.
            </p>

            <form action="" className={styles.form1}>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    Please tell us anything else that is relevant to the
                    application?
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <textarea
                    name=""
                    placeholder="Let us know here"
                    id=""
                    cols="40"
                    rows="5"
                    className={classNames(styles.answer, styles.textarea)}
                    value={formdata.otherMsg}
                    onChange={(e) => {
                      setFormdata({
                        ...formdata,
                        otherMsg: e.target.value,
                      });
                    }}
                  ></textarea>
                </div>
              </div>
            </form>
          </div>
          <div className={styles.btns}>
            <button
              onClick={SaveForLaterHandler}
              className={styles.saveForLater}
            >
              Save for later
            </button>
            <button onClick={submitHandler} className={styles.submitBtn}>
              Submit
            </button>
          </div>
        </div>
        <div className={styles.right}>
          <div className={styles.table}>
            <p>Your Offer in Principle</p>
            <table>
              <tr>
                <td>You are looking to borrow</td>
                <td>
                  {formdata.howMuchToBorrow ? formdata.howMuchToBorrow : "NA"}
                </td>
              </tr>
              <tr>
                <td>Based on your property being valued at</td>
                <td>
                  {formdata.propertyValuation
                    ? formdata.propertyValuation
                    : "NA"}
                </td>
              </tr>
              <tr>
                <td>
                  For how many months with interest rate of 0.69% Per Month
                </td>
                <td>
                  {formdata.numOfMonthsLoanFor
                    ? formdata.numOfMonthsLoanFor
                    : "NA"}
                </td>
              </tr>
              <tr>
                <td>Typical time to completion (days)</td>
                <td>10 </td>
              </tr>
            </table>
          </div>
          <div className={styles.table}>
            <p>Pay at end of term (Rolled)</p>
            <table>
              <tr>
                <td>Monthly Payments</td>
                <td>NA</td>
              </tr>
              <tr>
                <td>Amount Due</td>
                <td>{amountDue ? amountDue : "NA"}</td>
              </tr>
              <tr>
                <td>Gross LTV</td>
                <td>{isNaN(lTV) ? "NA" : lTV === "Infinity" ? "NA" : lTV}</td>
              </tr>
              <tr>
                <td>Maximum you can borrow</td>
                <td>{maxBorrowLimit ? maxBorrowLimit : "NA"}</td>
              </tr>
            </table>
          </div>
          <div className={styles.table}>
            <p>Pay monthly (Serviced)</p>
            <table>
              <tr>
                <td>Monthly Payments</td>
                <td>
                  {" "}
                  {!monthlyPayment
                    ? "NA"
                    : monthlyPayment === "Infinity"
                      ? "NA"
                      : monthlyPayment}
                </td>
              </tr>
              <tr>
                <td>Amount Due</td>
                <td>{amountDue ? amountDue : "NA"}</td>
              </tr>
              <tr>
                <td>Gross LTV</td>
                <td>{isNaN(lTV) ? "NA" : lTV === "Infinity" ? "NA" : lTV}</td>
              </tr>
              <tr>
                <td>Maximum you can borrow</td>
                <td>{maxBorrowLimit ? maxBorrowLimit : "NA"}</td>
              </tr>
            </table>
          </div>
        </div>
        {mql && step === "final" && resultsShown ? (
          <div className={styles.results}>
            <div className={styles.table}>
              <p>Your Offer in Principle</p>
              <table>
                <tr>
                  <td>You are looking to borrow</td>
                  <td>
                    {" "}
                    {formdata.howMuchToBorrow ? formdata.howMuchToBorrow : "NA"}
                  </td>
                </tr>
                <tr>
                  <td>Based on your property being valued at</td>
                  <td>
                    {" "}
                    {formdata.propertyValuation
                      ? formdata.propertyValuation
                      : "NA"}
                  </td>
                </tr>
                <tr>
                  <td>
                    For how many months with interest rate of 0.69% Per Month
                  </td>
                  <td>
                    {formdata.numOfMonthsLoanFor
                      ? formdata.numOfMonthsLoanFor
                      : "NA"}
                  </td>
                </tr>
                <tr>
                  <td>Typical time to completion (days)</td>
                  <td>10</td>
                </tr>
              </table>
            </div>
            <div className={styles.table}>
              <p>Pay at end of term (Rolled)</p>
              <table>
                <tr>
                  <td>Monthly Payments</td>
                  <td>NA</td>
                </tr>
                <tr>
                  <td>Amount Due</td>
                  <td>{amountDue ? amountDue : "NA"}</td>
                </tr>
                <tr>
                  <td>Gross LTV</td>
                  <td>{isNaN(lTV) ? "NA" : lTV === "Infinity" ? "NA" : lTV}</td>
                </tr>
                <tr>
                  <td>Maximum you can borrow</td>
                  <td>{maxBorrowLimit ? maxBorrowLimit : "NA"}</td>
                </tr>
              </table>
            </div>
            <div className={styles.table}>
              <p>Pay monthly (Serviced)</p>
              <table>
                <tr>
                  <td>Monthly Payments</td>
                  <td>
                    {!monthlyPayment
                      ? "NA"
                      : monthlyPayment === "Infinity"
                        ? "NA"
                        : monthlyPayment}
                  </td>
                </tr>
                <tr>
                  <td>Amount Due</td>
                  <td>{amountDue ? amountDue : "NA"}</td>
                </tr>
                <tr>
                  <td>Gross LTV</td>
                  <td>{isNaN(lTV) ? "NA" : lTV === "Infinity" ? "NA" : lTV}</td>
                </tr>
                <tr>
                  <td>Maximum you can borrow</td>
                  <td>{maxBorrowLimit ? maxBorrowLimit : "NA"}</td>
                </tr>
              </table>
            </div>
          </div>
        ) : null}
        <div className={styles.loadingContainer}>
          {showLoading && (
            <img src={loading} className={styles.loadingImg} alt="" />
          )}
        </div>
      </div>
    );
  };
  const initialFormUI = () => {
    return (
      <div className={styles.formPage}>
        <div className={styles.left}></div>
        <div className={styles.center}>
          <div className={styles.section} id="section4">
            <img src={logo} className={styles.logoImg} alt="" />
            <p className={styles.head}>Online Bridging Loan Application</p>
            <p
              className={styles.text}
              style={{ padding: "1.5rem 1.5rem 3rem 1.5rem" }}
            >
              Here you will be able to get access to the best market-leading
              bridging rates we offer The application process will take around
              10 minutes and at the end, you will receive a personalised
              Decision in Principle (DIP) The DIP will detail exactly how much
              it will cost to borrow the funds required and how long it will
              take to draw down the funds. So if you are ready let’s begin with
              some basic information
            </p>
            <form action="" className={styles.form1}>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    What is your full name?
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  <input
                    type="text"
                    placeholder="Enter your full name"
                    className={styles.answer}
                    value={formdata.name}
                    onChange={(e) =>
                      setFormdata({
                        ...formdata,
                        userName: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    What is the best number to contact you?
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <input
                    type="number"
                    placeholder="Enter contact number"
                    className={styles.answer}
                    value={formdata.contact}
                    onChange={(e) =>
                      setFormdata({
                        ...formdata,
                        userContact: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    And your email address?
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  <input
                    type="email"
                    placeholder="Enter email"
                    className={styles.answer}
                    value={formdata.email}
                    onChange={(e) =>
                      setFormdata({
                        ...formdata,
                        userEmail: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    Will you live in the property or is it an investment?
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <select
                    name=""
                    id=""
                    className={styles.answer}
                    value={formdata.propertyUse}
                    onChange={(e) =>
                      setFormdata({
                        ...formdata,
                        propertyUse: e.target.value,
                      })
                    }
                  >
                    <option value="" selected disabled>
                      select option
                    </option>
                    <option value="Investment">It is an investment</option>
                    <option value="ForLiving">
                      I'll be living in the property
                    </option>
                  </select>
                </div>
              </div>
              <div className={styles.inputBox}>
                <label htmlFor="" className={styles.question}>
                  <span className={styles.questionText}>
                    {" "}
                    How quickly do you need the money?
                    <GoInfo className={styles.infoIcon} />
                  </span>
                </label>
                <div className={styles.answerBlock}>
                  {" "}
                  <select
                    name=""
                    id=""
                    className={styles.answer}
                    value={formdata.whenMoneyNeeded}
                    onChange={(e) =>
                      setFormdata({
                        ...formdata,
                        whenMoneyNeeded: e.target.value,
                      })
                    }
                  >
                    <option value="" selected disabled>
                      select option
                    </option>
                    <option value="Urgently">Urgently within days</option>
                    <option value="InFewWeeks">
                      Required within a few weeks but less than 3 months
                    </option>
                  </select>
                </div>
              </div>
            </form>
            <div className={styles.btns}>
              <button
                onClick={intialSubmitHandler}
                className={styles.submitBtn}
              >
                Lets begin
              </button>
            </div>
          </div>
        </div>

        <div className={styles.right}></div>
      </div>
    );
  };
  return <>{step === "final" ? finalFormUI() : initialFormUI()}</>;
};

export default FormPage;
